/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_NameInputs */

const en_file_name = /** @type {(inputs: File_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Name`)
};

const fr_file_name = /** @type {(inputs: File_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du fichier`)
};

const de_file_name = /** @type {(inputs: File_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiname`)
};

const it_file_name = /** @type {(inputs: File_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del file`)
};

const ru_file_name = /** @type {(inputs: File_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя файла`)
};

const es_file_name = /** @type {(inputs: File_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del archivo`)
};

const zh_cn2_file_name = /** @type {(inputs: File_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件名`)
};

const ja_file_name = /** @type {(inputs: File_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイル名`)
};

const hi_file_name = /** @type {(inputs: File_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल नाम`)
};

const pt_pt2_file_name = /** @type {(inputs: File_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do arquivo`)
};

/**
* | output |
* | --- |
* | "File Name" |
*
* @param {File_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_name = /** @type {((inputs?: File_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_name(inputs)
	if (locale === "de") return de_file_name(inputs)
	if (locale === "it") return it_file_name(inputs)
	if (locale === "ru") return ru_file_name(inputs)
	if (locale === "es") return es_file_name(inputs)
	if (locale === "zh-CN") return zh_cn2_file_name(inputs)
	if (locale === "ja") return ja_file_name(inputs)
	if (locale === "hi") return hi_file_name(inputs)
	if (locale === "pt-PT") return pt_pt2_file_name(inputs)
	return en_file_name(inputs)
});